/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Read_Along_Ai_CostInputs */

const en_read_along_ai_cost = /** @type {(inputs: Read_Along_Ai_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Request cost: ${i?.cost} USD`)
};

const es_read_along_ai_cost = /** @type {(inputs: Read_Along_Ai_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Coste de la solicitud: ${i?.cost} USD`)
};

/**
* | output |
* | --- |
* | "Request cost: {cost} USD" |
*
* @param {Read_Along_Ai_CostInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_cost = /** @type {((inputs: Read_Along_Ai_CostInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_CostInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_cost(inputs)
	return en_read_along_ai_cost(inputs)
});